import { render } from "./InstallModal.vue?vue&type=template&id=2c300da4&ts=true"
import script from "./InstallModal.vue?vue&type=script&lang=ts"
export * from "./InstallModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__